// import httpUtil from "../assets/script/utils/http";

const state = {
  folder: [],
  folderId: 0,
  backUrl: "/",
  saveState: false,
  saveLoading: false
};

const mutations = {
  setfolder(state, payload) {
    state.folder = payload.dataSource;
  },
  AAddfolder(state, payload) {
    state.folder.push(payload);
  },
  setFolderId(state, id) {
    state.folderId = id;
  },
  setBackUrl(state, url) {
    state.backUrl = url;
  },
  setSaveState(state, type) {
    state.saveState = type;
  },
  setSaveLoading(state, type) {
    state.saveLoading = type;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
